import { useTransition, animated } from "react-spring";
import styles from "./emoji-dialog.module.scss";
import emojisJSON from "./emoji-list.json";

interface IEmoji {
  emoji: string;
  unicode_version: string;
}

interface IEmojis {
  [key: string]: IEmoji[];
}

function GetEmojiLayout({
  addEmoji,
}: {
  /*eslint-disable no-unused-vars */
  addEmoji: (emoji: string) => void;
}): JSX.Element {
  const emojis: IEmojis = emojisJSON;
  const emojikeys = Object.keys(emojis);
  return (
    <>
      {emojikeys.map(
        (group) =>
          group !== "Flags" && (
            <section key={group} className={styles.group_section}>
              <h5>{group}</h5>
              <div className={styles.emojis_section}>
                {(emojis[group as string] as IEmoji[]).map(
                  (emoji) =>
                    emoji.unicode_version !== "13.0" &&
                    emoji.unicode_version !== "14.0" && (
                      <span
                        key={emoji.emoji}
                        onClick={() => addEmoji(emoji.emoji)}
                      >
                        {emoji.emoji}
                      </span>
                    )
                )}
              </div>
            </section>
          )
      )}
    </>
  );
}

export default function EmojiDialog({
  opened,
  addEmoji,
}: {
  opened: boolean;
  addEmoji: (emoji: string) => void;
}): JSX.Element {
  const emojitrans = useTransition(opened, {
    from: {
      transform: "translateY(0%)",
      opacity: 0,
    },
    enter: {
      transform: "translateY(-100%)",
      opacity: 1,
    },
    leave: {
      transform: "translateY(0%)",
      opacity: 0,
    },
  });
  return emojitrans(
    (style, item) =>
      item && (
        <animated.div style={style} className={styles.emoji_dialog}>
          <GetEmojiLayout addEmoji={addEmoji} />
        </animated.div>
      )
  );
}
